import React from 'react';
import './OfferingCard.css';
import { Col, Row } from 'react-bootstrap';

const OfferingCard = ({ icon, title, description }) => (
  <div className="offering-card">
    <Row>
      <Col md={4}>
        <div className="icon">{icon}</div>
      </Col>
      <Col md={8}>
        <h3>{title}</h3>
        <p>{description}</p>
      </Col>
    </Row>
  </div>
);

export default OfferingCard;
